import { render, staticRenderFns } from "./ProductFormEcommerce.vue?vue&type=template&id=17c8a068&scoped=true&"
import script from "./ProductFormEcommerce.vue?vue&type=script&lang=ts&"
export * from "./ProductFormEcommerce.vue?vue&type=script&lang=ts&"
import style0 from "./ProductFormEcommerce.vue?vue&type=style&index=0&id=17c8a068&prod&lang=scss&scoped=true&"
import style1 from "./ProductFormEcommerce.vue?vue&type=style&index=1&id=17c8a068&prod&lang=scss&"
import style2 from "@/assets/stylesheets/v2/_action-btn.scss?vue&type=style&index=2&id=17c8a068&prod&lang=scss&%3B=true&scoped=true&"
import style3 from "@/assets/stylesheets/v2/shared/_number-field.scss?vue&type=style&index=3&prod&lang=scss&%3B=true&"
import style4 from "@/assets/stylesheets/v2/shared/_select-field.scss?vue&type=style&index=4&prod&lang=scss&%3B=true&"
import style5 from "@/assets/stylesheets/v2/shared/_combo-field.scss?vue&type=style&index=5&prod&lang=scss&%3B=true&"
import style6 from "@/assets/stylesheets/v2/shared/_checkbox-field.scss?vue&type=style&index=6&prod&lang=scss&%3B=true&"
import style7 from "@/assets/stylesheets/v2/shared/_bordered-container.scss?vue&type=style&index=7&id=17c8a068&prod&lang=scss&%3B=true&scoped=true&"
import style8 from "@/assets/stylesheets/v2/shared/_radio-field.scss?vue&type=style&index=8&prod&lang=scss&%3B=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c8a068",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VBtn,
  VCard,
  VCardActions,
  VCardTitle,
  VCheckbox,
  VChip,
  VCombobox,
  VDialog,
  VFlex,
  VForm,
  VIcon,
  VLayout,
  VRadio,
  VRadioGroup,
  VSelect,
  VSwitch,
  VTextField,
})
